// CONFIG

export abstract class Constants {
  public static readonly config_url = '/config.json';
  public static readonly oidc_callback_uri = '/callback';
  public static readonly oidc_logout_uri = '/loggedout';
}

interface IPublicConfig {
  application: IApplicationConfig;
  identity: IIdentityConfig;
}

interface IApplicationConfig {
  apiUrl: string;
  dmpCvr: string;
}

interface IIdentityConfig {
  authority: string;
  clientId: string;
}

export class DynamicConstants extends Constants {
  public config_url = Constants.config_url;
  public oidc_callback_uri = Constants.oidc_callback_uri;
  public oidc_logout_uri = Constants.oidc_logout_uri;

  public apiUrl: string;
  public dmpCvr: string[];
  public authority: string;
  public clientId: string;

  constructor(data: IPublicConfig) {
    super();
    this.apiUrl = data.application.apiUrl;
    this.dmpCvr = data.application.dmpCvr?.split(',');
    this.authority = data.identity.authority;
    this.clientId = data.identity.clientId;
  }
}

export const CONFIG_URI = '/config';
export const OIDC_LOGOUT_URI = '/loggedout';

// OIDC
export const OIDC_CALLBACK_URI = '/callback';

export const OIDC_SILENT_RENEW_URI = '/oidc-silent-renew';
export const OIDC_SCOPE = 'openid';
export const OIDC_RESPONSE_TYPE = 'code';
export const OIDC_EXPIRING_NOTIF_TIME = 120;

// CLAIM
export const IOT_ADMIN = 'miljoe_iot_administration';
export const IOT_AUTHORITY = 'miljoe_iot_myndighed';
export const IOT_READ_ONLY = 'READ-ONLY';

export default Constants;
